// extracted by css-extract-rspack-plugin
export default {"backLink":"_bca4f34","backLinkText":"_53968569"};